
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Inject, Injectable, InjectionToken, Injector, DOCUMENT } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { VendorListing, VendorsListingWithEntityAddressDto, VendorSummary } from '~/models/modules/vendor';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class VendorsService extends ApiServiceBase {
  vendorClosed: Subject<string> = new Subject<string>();
   vendorAdded: EventEmitter<any> = new EventEmitter();
   vendorUpdated: EventEmitter<any> = new EventEmitter();
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getVendor(id: number) {
    return this.http.get<VendorSummary>(this._url(`/${id}`));
  }


  getVendorsListing(paramsObj?:any, screenSiteId? : number, accountIds?: any) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.accountIds = accountIds;
    let params = createHttpParams(paramsObj);
    return this.http.get<VendorListing[]>(this._url(),{
      params
    });
  }

  getVendorsListingWithEntityAddress(paramsObj?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    //return this.http.get<VendorsListingWithEntityAddressDto[]>(this._url(`/withentityaddress`));
    return this.http.get<VendorsListingWithEntityAddressDto[]>(`${this._url}/withentityaddress`, { params: paramsObj });
  }

  getVendorWithEntityAddress(id: number) {
    return this.http.get<VendorsListingWithEntityAddressDto>(this._url(`/withentityaddress/${id}`));
  }


  getVendors(paramsObj?: any, model?: any, screenSiteId? : number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<VendorSummary[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
}

  CheckIfVendorHasApprovalCycle(vendorId : number, siteId : number){
    return this.http.get(this._url(`/Vendors/${vendorId}/Sites/${siteId}/ApprovalCycles`));
  }

  getVendorsBySiteId(siteIds: number[]) {
    return this.http.post<VendorListing[]>(this._url(`/site`), { siteIds });
  }

  getAccountsVendors(accountIds: any[], paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    model['accountIds'] = accountIds;

    return this.http
      .post<VendorSummary[]>(this._url(`/accounts`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  createVendor(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateVendor(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteVendor(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }
  deactivateVendor(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateVendorBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateVendor(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }
  reactivateVendorBatch(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }

  getNumberItemForVendor(id: number) {
    return this.client.get(this._url(`/number-item-vendor/${id}`));
  }

  getNumberPoForVendor(id: number) {
    return this.client.get(this._url(`/number-po-vendor/${id}`));
  }

  getSummedOrderPastMonth(id: number) {
    return this.client.get(this._url(`/summed-orders-last-month/${id}`));
  }

  getBackorderedStockVendor(id: number) {
    return this.client.get(this._url(`/backordered-stock-vendor/${id}`));
  }


  GetNumberOfPoByCustomer(vendorId : number){
    return this.client.get(this._url(`/Vendors/${vendorId}/NumberOfPOChart`));
  }


  GetReceiveItemsByCategoryByCustomer(vendorId : number){
    return this.client.get(this._url(`/Vendors/${vendorId}/ReceievedItemsByCategory`));
  }



  GetReceiveItemsByStockNumberByCustomer(vendorId : number){
    return this.client.get(this._url(`/Vendors/${vendorId}/ReceivedItemsByStockNumber`));
  }


  GetNumberOfPoBackOrderByCustomer(vendorId : number){
    return this.client.get(this._url(`/Vendors/${vendorId}/PoBackOrder`));
  }


  GetTransactionHistoryByVendor(vendorId : number){
    return this.client.get(this._url(`/Vendors/${vendorId}/TransactionHistory`));
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Vendors${v}`);
  }

  vendorFormClosed(newVendor: any) {
    this.vendorClosed.next(newVendor);
  }
}
